import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentLanguage } from '../features/langSlice';
import { useGetContentsByTagWebQuery } from '../features/contentsApiSlice';
import {
  AboutUs1,
  AboutUs2,
  AboutUs3,
  AboutUs4,
  AboutUs5,
  HowRiiseMake,
  OurMission,
  OurTeam,
  OurTeamDesc1,
  OurTeamDesc2,
  OurTeamDesc3,
  RiiseBuilt1,
  RiiseBuilt1Desc,
  RiiseBuilt2,
  RiiseBuilt2Desc,
  RiiseBuilt3,
  RiiseBuilt3Desc,
  RiiseBuilt4,
  RiiseBuilt4Desc,
  SimpleSupplements,
} from '../Constants';
import { useTranslation } from 'react-i18next';
import AboutMobile from '../assets/riise-for-you.webp';
import AleAndPaul from '../assets/ale-and-paul.webp';
import ArrowUpward from '../assets/arrow-upward.png';
const AboutUs = () => {
  const { t } = useTranslation();
  const selectedLang = useSelector(selectCurrentLanguage);
  const [lang, setLang] = useState();

  const [data, setData] = useState([]);
  const [skip] = useState(false);

  const [banner, setBanner] = useState('');
  const [pictures] = useState([]);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const {
    data: fetchContents,
    isSuccess,
    refetch,
  } = useGetContentsByTagWebQuery({ tag: 'About', lang: lang, skip: skip });

  useEffect(() => {
    setLang(selectedLang === 'us' ? 'en' : selectedLang);

    refetch();
  }, [refetch, lang, selectedLang]);

  useEffect(() => {
    if (isSuccess) {
      setData(fetchContents.data);

      //setPictures([])

      if (fetchContents.data[0]) {
        setBanner(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[0].picture}`);
        pictures.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[0].picture}`);
        pictures.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[2].picture}`);
        pictures.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[3].picture}`);
        pictures.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[4].picture}`);
        pictures.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[5].picture}`);

        pictures.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[7].picture}`);
        pictures.push(`${process.env.REACT_APP_PUBLIC_URL}${fetchContents.data[8].picture}`);
      }
    }
  }, [fetchContents]);

  return (
    <>
      <section
        className={`breadcrumbs-wrapper-new !t-bg-[#fbfaf1] !t-bg-no-repeat t-bg-cover`}
        style={{
          backgroundImage: isDesktop ? `url(${banner})` : `url(${AboutMobile})`,
          backgroundSize: isDesktop ? '100%' : '70%',
          backgroundPositionX: 'right',
          backgroundPositionY: 'bottom',
        }}
      >
        <div className="container">
          <div className="t-flex t-flex-col t-gap-8">
            <div className="t-flex t-flex-col t-items-center t-justify-center">
              <p
                className="!t-m-0 t-text-secondary t-font-semibold t-text-center !t-text-[13px] t-uppercase t-tracking-widest"
                style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
              >
                {t(OurMission)}
              </p>
              <h1
                className="!t-m-0 t-text-secondary t-font-normal t-text-center !t-text-[32px]"
                style={{ fontFamily: "'DM Serif Display', serif" }}
              >
                {t(SimpleSupplements)}
              </h1>
            </div>
            <div className="t-w-2/3 md:t-w1/2 md:t-mx-auto t-flex t-flex-col t-items-start md:t-items-center t-gap-4">
              <p className="!t-m-0 t-text-secondary md:t-text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t(AboutUs1)}</p>
              <p className="!t-m-0 t-text-secondary md:t-text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t(AboutUs2)}</p>
              <p className="!t-m-0 t-text-secondary md:t-text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t(AboutUs3)}</p>
              <p className="!t-m-0 t-text-secondary md:t-text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t(AboutUs4)}</p>
              <p className="!t-m-0 t-text-secondary md:t-text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t(AboutUs5)}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="difference-section inner-page">
        <div className="container">
          <div className="col-lg-10 mx-auto">
            <div className="title-wrapper">
              <h2 className="title2 t-text-center mb-4 !t-text-[32px] !t-font-normal" style={{ fontFamily: "'DM Serif Display', serif" }}>{t(HowRiiseMake)}</h2>
              <div className="text-start">
                <div
                  className="lh-base md:t-text-center !t-text-[14px] !t-font-normal"
                  style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: '14px', fontWeight: '400' }}
                >
                  {data[1] && (
                    <div
                      style={{ fontSize: '14px', fontWeight: '400' }}
                      dangerouslySetInnerHTML={{
                        __html: data[1].contents
                          .replace(/<small>/gi, '<span>')
                          .replace(/<\/small>/gi, '</span>'),
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="t-max-w-[500px] !t-w-full t-mx-auto t-grid t-grid-cols-2 lg:grid-cols-4 t-gap-4">
                <Card img={pictures[1]} title={t(RiiseBuilt1)} desc={t(RiiseBuilt1Desc)} />
                <Card img={pictures[2]} title={t(RiiseBuilt2)} desc={t(RiiseBuilt2Desc)} />
                <Card img={pictures[3]} title={t(RiiseBuilt3)} desc={t(RiiseBuilt3Desc)} />
                <Card img={pictures[4]} title={t(RiiseBuilt4)} desc={t(RiiseBuilt4Desc)} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="adventure-section section-padding pt-0 inner-page">
        <div className="container">
          <div className="t-flex t-flex-col t-items-center t-justify-center t-mb-8 t-gap-4">
            <h2 className="title2 !t-m-0 !t-text-center !t-text-[32px] !t-font-normal" style={{ fontFamily: "'DM Serif Display', serif" }}>{t(OurTeam)}</h2>
            <p className="!t-m-0 md:t-max-w-[500px] md:t-mx-auto md:t-text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t(OurTeamDesc1)}</p>
            <p className="!t-m-0 md:t-max-w-[500px] md:t-mx-auto md:t-text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t(OurTeamDesc2)}</p>
            <div className="t-relative t-flex t-flex-col t-gap-4">
              <img src={AleAndPaul} alt="" className="t-w-full t-h-auto t-max-w-[400px] t-rounded-lg" />
              {/* <img /> */}
              <div className="t-flex t-items-start t-justify-between t-gap-4">
                <div className="t-flex t-flex-col t-items-center t-justify-center">
                  <img src={ArrowUpward} alt="" className="t-w-16" />
                  <FounderInfo
                    name="Paul-Antoine Richard"
                    strava="https://www.strava.com/athletes/98274922"
                    position="Co-founder, Marketing & Sales"
                  />
                </div>
                <div className="t-flex t-flex-col t-items-center t-justify-center">
                  <img src={ArrowUpward} alt="" className="t-w-12 !-t-rotate-[60deg]" />
                  <FounderInfo
                    name="Alessandro Mambrini"
                    strava="https://www.strava.com/athletes/59293951"
                    position="Co-founder, Product & Operations"
                  />
                </div>
              </div>
            </div>
            <p className="!t-m-0 md:t-max-w-[500px] md:t-mx-auto md:t-text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              {t(OurTeamDesc3)}
              <span>
                <a href="mailto:hi@weriise.co" className="t-text-secondary">
                  hi@weriise.co
                </a>
              </span>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

const Card = ({ img, title, desc }) => {
  return (
    <div className="t-w-full t-max-w-[300px] t-flex t-flex-col t-items-center t-justify-center t-bg-gray-100 t-rounded-lg t-p-2 t-gap-1">
      <img src={img} alt="" className="t-h-18 t-w-14" />
      <h4 className="!t-m-0 t-font-normal t-text-center !t-text-base" style={{ fontFamily: "'DM Serif Display', serif" }}>
        {title}
      </h4>
      <p className="!t-m-0 t-text-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{desc}</p>
    </div>
  );
};

const FounderInfo = ({ name, strava, position }) => {
  return (
    <div className="t-flex t-flex-col t-items-center t-justify-center" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <p className="!t-m-0 !t-text-[13px] !t-leading-[18px] t-text-center">{name}</p>
      <a
        href={strava}
        className="!t-m-0 !t-text-black !t-underline !t-text-[13px] !t-leading-[18px]"
        target="_blank"
        rel="noreferrer"
      >
        Strava
      </a>
      <p className="!t-m-0 !t-text-[13px] !t-leading-[18px] t-text-center">{position}</p>
    </div>
  );
};

export default AboutUs;
